import * as S from './ProgressBar.style';

type ProgressBarProps = {
  initProgressRate: number;
  maxProgressRate?: number;
  maxProgress: number;
  progress: number;
};

export default function ProgressBar({
  initProgressRate,
  maxProgressRate = 100,
  maxProgress,
  progress,
}: ProgressBarProps) {
  return (
    <S.Container>
      <S.GrayBar />
      <S.Progress
        initProgressRate={initProgressRate}
        maxProgressRate={maxProgressRate}
        maxProgress={maxProgress}
        progress={progress}
      />
    </S.Container>
  );
}
